var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDropDown16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_drop_down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_drop_down_24px",
    d: "M4.66667 6.33333L8 9.66667L11.3333 6.33333H4.66667Z",
    fill: "#696F88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDropDown16);
export default __webpack_public_path__ + "static/media/arrow-drop-down-16.089e6d54bc5f782353d915fd3bb14e54.svg";
export { ForwardRef as ReactComponent };